module.exports = __webpack_public_path__ + "static/media/TLC-thermal.4734d12d.svg";